import React from 'react';
import { useTranslation } from 'react-i18next';
import Icon from '../../components/AppIcon';
import {
  formatMessagePeriod,
  isMessageCurrentlyActive,
} from '../../lib/platformMessagesUtils';

const PlatformMessagesTable = ({ messages, loading, onEdit, onDelete }) => {
  const { t, i18n } = useTranslation();
  const locale = i18n.language?.startsWith('en') ? 'en-GB' : 'fr-FR';

  if (loading) {
    return (
      <p className="text-sm text-muted-foreground py-8 text-center">
        {t('common.loading')}
      </p>
    );
  }

  if (!messages?.length) {
    return (
      <p className="text-sm text-muted-foreground py-8 text-center">
        {t('adminPlatformMessages.empty')}
      </p>
    );
  }

  return (
    <div className="overflow-x-auto">
      <table className="w-full text-sm">
        <thead>
          <tr className="border-b border-border text-left text-muted-foreground">
            <th className="py-3 px-4 font-medium">{t('adminPlatformMessages.columns.title')}</th>
            <th className="py-3 px-4 font-medium">{t('adminPlatformMessages.columns.type')}</th>
            <th className="py-3 px-4 font-medium">{t('adminPlatformMessages.columns.country')}</th>
            <th className="py-3 px-4 font-medium">{t('adminPlatformMessages.columns.period')}</th>
            <th className="py-3 px-4 font-medium">{t('adminPlatformMessages.columns.status')}</th>
            <th className="py-3 px-4 font-medium text-right">{t('adminPlatformMessages.columns.actions')}</th>
          </tr>
        </thead>
        <tbody>
          {messages.map((msg) => {
            const live = isMessageCurrentlyActive(msg);
            return (
              <tr key={msg.id} className="border-b border-border/60 hover:bg-muted/30">
                <td className="py-3 px-4 font-medium text-foreground">{msg.title}</td>
                <td className="py-3 px-4">
                  {t(`adminPlatformMessages.types.${msg.messageType}`)}
                </td>
                <td className="py-3 px-4">
                  {msg.country?.countryName || t('adminPlatformMessages.allCountries')}
                </td>
                <td className="py-3 px-4 text-muted-foreground whitespace-nowrap">
                  {formatMessagePeriod(msg.startsAt, msg.endsAt, locale)}
                </td>
                <td className="py-3 px-4">
                  {!msg.isActive ? (
                    <span className="text-xs px-2 py-0.5 rounded-full bg-muted text-muted-foreground">
                      {t('adminPlatformMessages.status.inactive')}
                    </span>
                  ) : live ? (
                    <span className="text-xs px-2 py-0.5 rounded-full bg-success/15 text-success">
                      {t('adminPlatformMessages.status.live')}
                    </span>
                  ) : (
                    <span className="text-xs px-2 py-0.5 rounded-full bg-muted text-muted-foreground">
                      {t('adminPlatformMessages.status.scheduled')}
                    </span>
                  )}
                </td>
                <td className="py-3 px-4">
                  <div className="flex justify-end gap-1">
                    <button
                      type="button"
                      onClick={() => onEdit(msg)}
                      className="p-2 rounded-lg hover:bg-muted"
                      title={t('common.edit')}
                    >
                      <Icon name="Pencil" size={16} />
                    </button>
                    <button
                      type="button"
                      onClick={() => onDelete(msg)}
                      className="p-2 rounded-lg hover:bg-muted text-error"
                      title={t('common.delete')}
                    >
                      <Icon name="Trash2" size={16} />
                    </button>
                  </div>
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
};

export default PlatformMessagesTable;
